import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  mainContent: {
    display: 'grid',
    gridTemplateColumns: '30% 70%',
    flex: 1,
    minHeight: '400px',
    backgroundColor: '#F8F9FA',
    padding: '0px 0px 0px 24px ',
    overflow: 'hidden'
  },
  sidebar: {
    borderRight: '1px solid #EEF0F2',
    padding: '24px 24px 24px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  sidebarItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderLeft: '8px solid transparent',

    '&:hover': {
      backgroundColor: '#F0F4F8'
    }
  },
  sidebarItemActive: {
    borderColor: '#1E96FC',
    '& $sidebarItemText': {
      fontWeight: 600
    }
  },
  sidebarItemIcon: {
    color: '#5D7083',
    fontSize: '20px'
  },
  sidebarItemText: {
    color: '#5D7083',
    fontSize: '14px'
  },
  contentArea: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    overflow: 'auto'
  },
  contentSection: {
    padding: '0 24px'
  },
  sectionHeading: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#20262D',
    marginBottom: '12px'
  },
  sectionDescription: {
    fontSize: '14px',
    color: '#333D47',
    marginBottom: '20px'
  },
  labelsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  labelPill: {
    padding: '8px 12px',
    borderRadius: '120px',
    backgroundColor: '#F8F9FA',
    border: '1px solid #AFBAC6',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#5D7083',
    width: 'fit-content',
    textAlign: 'center',
    transition: 'all 0.1s ease',
    '&:hover': {
      borderColor: '#1E96FC'
    }
  },
  labelPillSelected: {
    borderColor: '#1E96FC',
    boxShadow: 'inset 0 0 0 1px #1E96FC',
    fontWeight: 500
  },
  customLabelSection: {
    marginTop: '20px',
    maxWidth: '180px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  checkboxSection: {
    padding: '12px 24px 24px'
  },
  labelClass: {
    fontWeight: 'normal'
  }
}));
